export const environment = {
  production: true,
  apiUrl: '',
  kiosk: false,
  clientOnly: true
};
